import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import logo from 'assets/img/logo.svg';

interface PageContainerProps extends PropsWithChildren {
  className?: string;
}

function PageContainer({ className, children }: PageContainerProps) {
  return (
    <div
      className={classNames(
        'min-h-screen bg-white bg-[center_bottom_3rem] bg-no-repeat px-12 py-5 pb-32',
        className
      )}
      style={{ backgroundImage: `url(${logo})` }}
    >
      {children}
    </div>
  );
}

export default PageContainer;
